import { put, call, takeLatest } from "redux-saga/effects";
import axios from 'axios';

import API_ENDPOINTS from "@services/apiConfig";
import { reportTypeConstants } from '@constants/common';

/********** ACTION_TYPES **********/
export const actionTypes = {
  shareReport: "incentives/INITIATE_SHARE_REPORT",
  shareReportFailed: "incentives/SHARE_REPORT_FAILED",
  shareReportFulfilled: "incentives/SHARE_REPORT_FULFILLED",
  closeDialog: "incentives/CLOSE_DIALOG",
};

/********** REDUCER **********/
const initialState = {
  fetching: false,
  fetched: false,
  data: null,
  errMsg: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.shareReport: {
      return { ...state, fetching: true };
    }
    case actionTypes.shareReportFailed: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        errMsg: action.payload,
      };
    }
    case actionTypes.shareReportFulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload,
        errMsg: null,
      };
    }
    case actionTypes.closeDialog: {
      return { initialState }
    }
    default: {
      return state;
    }
  }
};

/********** SELECTORS **********/
export const selectors = {
  isSuccess: state => state.partnerApp.incentivesReports.data,
  isError: state => state.partnerApp.incentivesReports.errMsg,
  isFetched: state => state.partnerApp.incentivesReports.fetched,
};

/********** ACTION_CREATORS **********/
export const actions = {
  shareReport: (data, reportType) => ({
    type: actionTypes.shareReport,
    payload: data,
    reportType
  }),
  shareReportFailed: (data) => ({
    type: actionTypes.shareReportFailed,
    payload: data,
  }),
  shareReportFulfilled: (data) => ({
    type: actionTypes.shareReportFulfilled,
    payload: data,
  }),
  closeDialog: () => ({
    type: actionTypes.closeDialog,
  })
};

/********** WORKERS **********/
function* shareReportWorker(action) {
  const { reportType, payload } = action;
  const { mid } = payload;
  try {
    const reportUrl = reportTypeConstants[reportType];
    const response = yield call(
        [axios, 'post'],
        API_ENDPOINTS.INCENTIVES[reportUrl](mid),
        { 
          filters : payload.filters,
          recipients: payload.recipients,
        }
      )
    if (response.status == 200) {
      yield put(actions.shareReportFulfilled(response.data.status));
    }
  } catch (err) {
    console.log(err);
    let errMsg;
    if(err.response.status == 429 ) {
      errMsg = "You have exceeded the limit for report requests. Please wait for one minute to request a file again.";
    }
    else{
      errMsg = (err && err.response.data.error) || "Something went wrong";
    }
    yield put(actions.shareReportFailed(errMsg));
  }
}


/********** SAGAS **********/
export function* saga() {
  yield takeLatest(actionTypes.shareReport, shareReportWorker);
}